export interface AriaLabels {
  next: string;
  previous: string;
}

export interface CardTile {
  affiliationId: string;
  imageAlt: string;
  imageSrc: string;
  title: string;
  type: string;
  value: string;
}

export interface Unlimited {
  cardDesc: string;
  cardValidity: string;
  imgAlt: string;
  imgSrc: string;
  cardTCLabel: string;
  cardTCLink: string;
  cardTCId: string;
  membershipDesc: string;
  membershipTitle: string;
  membershipValidity: string;
}

export interface VisitScale {
  desc: string;
  type: string;
}

export interface SkyClub {
  ariaLabels: AriaLabels;
  cardTile: CardTile[];
  ofLabel: string;
  title: string;
  tooltipInfo: string;
  tooltipLabel: string;
  unlimited: Unlimited;
  visitScale: VisitScale[];
}
